export default class AccordionMenu {
  constructor() {
    this.$menu = $('.accordion-menu');
    this.$openBtn = $('.header-nav .nav-items .menu');
    this.$closeBtn = $('.accordion-menu .close-btn');

    this._addEvent();
  }

  _addEvent() {
    this.$openBtn.on('click', () => {
      this.$menu.slideDown(300);
    });

    this.$closeBtn.on('click', () => {
      this.$menu.slideUp(300);
    });
  }
}
